import { each } from 'jquery';
import 'select2';
$.fn.select2.amd.define('select2/i18n/ru',[],require("select2/src/js/select2/i18n/ru"));
$.fn.select2.amd.define('select2/i18n/uk',[],require("select2/src/js/select2/i18n/uk"));
//$.fn.select2.defaults.set( "placeholder", "" );

export default new class DropSelect {
  constructor() {
    this.init();
  }

  init() {
    document.querySelectorAll('select.select2').forEach((obField) => {

      const that = this;

      const fieldName = $(obField).attr('name');

      let source = this.remoteData(obField, that);
      // eslint-disable-next-line no-console
      console.log(obField);

      if(fieldName == 'region'){
        source = {
          allowClear: true,
        };
      }

      //const source = this.localData(obField);


      const select2 = $(obField).select2(source);
      
      select2.on("select2:select", (e) => { 

        if(that.method == 'onCityOptions'){
          // eslint-disable-next-line no-console
          console.log(e.params.data);
          document.querySelector('#ref').value = e.params.data.ref;
        }

        if(that.method == 'onReserveCityOptions'){
          this.fireEvent({'city': e.params.data.id});
        }

        if(that.method == 'onReserveDealerOptions'){
          this.fireEvent({'dealer': e.params.data.id});
        }

        if(that.method == 'onReserveRegionOptions'){
          this.fireEvent({'region': e.params.data.id});
        }
      });
    });
  }

  remoteData(obField, that) {
    const fieldName = $(obField).attr('name');
    const fieldPlaceholder = $(obField).attr('placeholder');

    return {
      allowClear: true,
      placeholder: {
        placeholder: fieldPlaceholder
      },
      ajax: {
        transport(params, success, failure) {
        
          that.setMethod(fieldName);

          const $request = $.request(that.method, {
            data: params.data,
          });

          $request.done(success);
          $request.fail(failure);

          return $request;
        },

        dataType: 'json',
        data(params) {

          return {
            term: params.term,
            ref: document.querySelector('#ref') !== null ? document.querySelector('#ref').value : '',
          };
        },
        processResults: function (data) {
          return {
            results: data.result
          };
        },
      },
    }
  }

  fireEvent(message) {
    document.dispatchEvent(new CustomEvent("onFilter", {
      bubbles: true, 
      detail: {status: true, message}
    }));
  }

  setMethod(fieldName) {
    let method = 'onCityOptions';

    if( fieldName == 'street'){
      method = 'onStreetOptions';
    }

    if( fieldName == 'region'){
      method = 'onRegionOptions';
    }

    if( fieldName == 'filter_reserve_region'){
      method = 'onReserveRegionOptions';
    }

    if( fieldName == 'filter_reserve_dealer'){
      method = 'onReserveDealerOptions';
    }

    this.method = method;
  }
}();
